import formCheckEmail from '../../../utils/forms/form-email-check';
import {
  validEmail,
  validMobileNumber,
  validLicenceNumber,
} from '../../../utils/validators/GenericValidators';

export const newDriverFormvalidate = (values, country) => {
  const errors = {};
  const requiredFields = [
    'newDriverFirstName',
    'newDriverSurName',
    'newDriverMobileNo',
    'newDriverEmailID',
    'newDriverAllocationDate',
  ];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required';
    }
  });
  if (
    values.newDriverEmailID &&
    //!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailID)
    !formCheckEmail(values.newDriverEmailID)
  ) {
    errors.newDriverEmailID = 'Invalid email address';
  }

  /* if (values.newDriverLicenceNo && !validLicenceNumber(values.newDriverLicenceNo)) {
        errors.newDriverLicenceNo = "Invalid Licence number";
    }*/

  if (
    values.newDriverMobileNo &&
    !validMobileNumber(values.newDriverMobileNo, country.value)
  ) {
    errors.newDriverMobileNo = 'Invalid Mobile number';
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/features/relocations/driver/validators.js